<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :max-width="$spec.dialog_standard_max_width"
  >
    <v-card>
      <v-card-title class="headline" v-text="title"></v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-select v-model="type" :items="typeItems" label="類型"></v-select>
          <v-text-field
            v-model="name"
            :rules="nameRules"
            label="寵物名"
          ></v-text-field>
          <v-select
            v-model="gender"
            :items="genderItems"
            label="姓別"
          ></v-select>
          <v-text-field
            v-model="breed"
            :rules="breedRules"
            label="品種"
          ></v-text-field>
          <v-text-field
            v-model="ownerName"
            label="飼主"
            :disabled="petId !== null"
            v-if="petId !== null"
          ></v-text-field>
          <v-text-field
            :loading="ownerPhoneLoading"
            v-model="ownerPhone"
            :rules="ownerPhoneRules"
            label="飼主手機"
            :success="ownExist"
            :disabled="petId !== null"
          ></v-text-field>
        </v-form>
        <base-date-picker
          appendIcon="mdi-calendar-month"
          label="出生日期"
          ref="datePicker"
        ></base-date-picker>
        <v-textarea
          v-model="info"
          label="備註"
          counter="300"
          :rules="infoRules"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="dialog = false">取消</v-btn>
        <v-btn
          color="green"
          text
          @click="saveOrUpdate()"
          :loading="loading"
          :disabled="ownerPhoneLoading"
          >儲存</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import BaseDatePicker from "../common/BaseDatePicker";

export default {
  components: {
    BaseDatePicker
  },
  data() {
    return {
      dialog: false,
      title: "",
      name: "",
      nameRules: [v => !!v || "請輸入姓名"],
      type: "",
      typeItems: [
        { text: "貓咪", value: "cat" },
        { text: "狗狗", value: "dog" },
        { text: "其他", value: "other" }
      ],
      gender: "",
      genderItems: [
        { text: "公", value: "male" },
        { text: "母", value: "female" }
      ],
      breed: "",
      breedRules: [v => !!v || "請輸入品種"],
      ownerPhone: "",
      ownerPhoneRules: [
        v => !!v || "請輸入飼主手機",
        v =>
          (String(v).length > 9 && !isNaN(parseInt(v))) || "請輸入合法手機帳號",
        () => {
          if (this.ownerPhoneLoading) {
            return true;
          } else {
            return this.ownExist || "飼主帳號不存在";
          }
        }
      ],
      ownerPhoneLoading: false,
      ownExist: false,
      info: "",
      infoRules: [v => !v || v.length <= 300 || "最多300字元"],
      ownerName: "",
      petId: null,
      loading: false
    };
  },
  watch: {
    async ownerPhone(val) {
      if (this.petId) {
        return;
      }

      if (String(val).length > 9) {
        console.log(val);
        this.ownExist = false;
        this.ownerPhoneLoading = true;
        let response = await this.$ajax.post(
          `${this.$config.apiUrl}/${this.$my.getClinic()}/search/user`,
          { phone: val }
        );
        if (response.data.length > 0) {
          this.ownerName = response.data[0].name;
        }
        this.ownerPhoneLoading = false;
        this.ownExist = response.data.length > 0;
        this.$refs.form.validate();
      }
    }
  },
  methods: {
    async create(phone, name) {
      this.petId = null;
      this.title = "新增寵物";
      if (this.$refs.datePicker) {
        this.$refs.datePicker.reset();
      }

      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.ownerPhoneLoading = false;
      this.ownExist = false;
      await this.$nextTick();

      this.type = this.typeItems[0].value;
      this.gender = this.genderItems[0].value;
      this.info = "";

      this.loading = false;
      this.dialog = true;
      await this.$nextTick();
      if (phone) {
        this.ownerPhone = phone;
        this.ownerName = name;
        this.$refs.form.resetValidation();
      }
    },
    async edit(id, pet) {
      this.petId = id;
      this.title = "編輯寵物";

      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.ownerPhoneLoading = false;
      this.ownExist = true;
      await this.$nextTick();

      this.name = pet.name;
      this.type = pet.type;
      this.gender = pet.gender;
      this.breed = pet.breed;
      this.ownerName = pet.userName;
      this.ownerPhone = pet.userPhone;
      this.info = pet.info;
      this.dialog = true;
      await this.$nextTick();
      if (this.$refs.datePicker) {
        this.$refs.datePicker.setDate(pet.birth);
      }
    },
    async saveOrUpdate() {
      if (this.$refs.form.validate()) {
        let postData = {
          type: this.type,
          name: this.name,
          breed: this.breed,
          gender: this.gender,
          birth: this.$refs.datePicker.getDate(),
          userPhone: this.ownerPhone,
          userName: this.ownerName,
          clinic: this.$my.getClinic(),
          info: this.info
        };
        console.log("post data:" + JSON.stringify(postData));
        this.loading = true;
        let response;
        if (this.petId) {
          response = await this.$ajax.put(
            `${this.$config.apiUrl}/${this.$my.getClinic()}/pets/${this.petId}`,
            postData
          );
        } else {
          response = await this.$ajax.post(
            `${this.$config.apiUrl}/${this.$my.getClinic()}/pets/`,
            postData
          );
        }

        console.log("response:" + JSON.stringify(response.data));
        this.dialog = false;
        this.loading = false;

        this.$emit("done");
      }
    }
  }
};
</script>
